import React, { useEffect } from 'react'
import { PlayerProfileContext } from '../../Context'
import { BoxWithTwoColumns } from '../../Components/Layout'
import { SectionHeading } from '../../Components/Headers'
import { Bio } from './components'
import { Value, ValuesInColumnContainer } from './components'
import { concatCollege } from '../../Utils/formatting/formatting'
import { AccoladeItem } from './components/Accolade/Accolade'
import { MerchSection } from './components/Merch/MerchSection'
import { AdUnit } from '../../Components/Ads/AdUnit'
import { MediaTab } from './MediaTab'

export const ProfileTab: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { player, team } = React.useContext(PlayerProfileContext)!
  const color = team?.teamColor || undefined

  useEffect(() => {
    if (!player) return
  }, [player])

  const renderContractValue = () => {
    if (!player) return
    if (!player.contractStatus) return ''
    if (player.contractStatus.length !== 4) {
      return player.contractStatus
    }
    return `thru ${player.contractStatus} season`
  }
  if (!player) return <></>

  return (
    <>
      <BoxWithTwoColumns reverseOnWrap>
        <div>
          {player.contractStatus && (
            <>
              <SectionHeading headingText="Contract" bottomBorder />
              <ValuesInColumnContainer>
                <Value label="Contract Length" value={renderContractValue()} />
              </ValuesInColumnContainer>
            </>
          )}
          {player.accolades && player.accolades.length > 0 && (
            <>
              <SectionHeading headingText="Accolades" bottomBorder />
              <ValuesInColumnContainer>
                {player.accolades.map((acc) => (
                  <AccoladeItem key={acc.awardName} accolade={acc} teamColor={color} />
                ))}
              </ValuesInColumnContainer>
            </>
          )}
        </div>
        <div>
          <SectionHeading headingText="Profile" bottomBorder={true} />
          <ValuesInColumnContainer>
            {player.nickname && <Value label="Nickname" value={player.nickname} />}
            {player?.currentTeam?.positionName && (
              <Value label="Position" value={player.currentTeam.positionName} />
            )}
            {player?.handedness && <Value label="Hand" value={player.handedness} />}
            <Value label="Weight" value={player.weight} />
            <Value label="Height" value={player.height} />
            {player.age && <Value label="Age" value={player.age} />}
            {player.college && (
              <Value
                label="College"
                value={concatCollege(player.college, player?.collegeYear)}
              />
            )}
            {player.hometown && <Value label="Hometown" value={player.hometown} />}
            {player.highSchool && (
              <Value label="High School" value={player.highSchool} />
            )}
            {player.clubTeam && <Value label="Club Team" value={player.clubTeam} />}
          </ValuesInColumnContainer>
        </div>
      </BoxWithTwoColumns>

      <MediaTab />

      <AdUnit bannerType="bannerSecond" aria-label="Player profile ad second" />

      <BoxWithTwoColumns reverseOnWrap>
        <div>
          <SectionHeading headingText="Bio" />
          <Bio text={player.bio} />
        </div>
        <div>
          <MerchSection />
        </div>
      </BoxWithTwoColumns>
      {player.extraInfo && (
        <>
          <BoxWithTwoColumns>
            <ValuesInColumnContainer>
              <SectionHeading headingText={`Get to know ${player.firstName}`} />
              {player.extraInfo.favMemory && (
                <Value label={player.extraInfo.favMemory} value="Favorite Lax Memory" />
              )}
              {player.extraInfo.fact && (
                <Value label={player.extraInfo.fact} value="Fact" />
              )}
              {player.extraInfo.favFoods && (
                <Value label={player.extraInfo.favFoods} value="Favorite Food" />
              )}
              {player.extraInfo.favShows && (
                <Value label={player.extraInfo.favShows} value="Favorite Shows" />
              )}
            </ValuesInColumnContainer>
            <ValuesInColumnContainer>
              <SectionHeading headingText={`Weapon of Choice`} />
              {player.extraInfo.gearHead && (
                <Value label={player.extraInfo.gearHead} value="Head" />
              )}
              {player.extraInfo.gearMesh && (
                <Value label={player.extraInfo.gearMesh} value="Mesh" />
              )}
              {player.extraInfo.gearShaft && (
                <Value label={player.extraInfo.gearShaft} value="Shaft" />
              )}
            </ValuesInColumnContainer>
          </BoxWithTwoColumns>
        </>
      )}
      <AdUnit bannerType="bannerThird" aria-label="Player profile ad third" />
    </>
  )
}
